import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-face",
  "use": "icon-face-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-face\">\n<path d=\"M14.3076 11.25L14.8259 7.65625H11.5306V5.3125C11.5306 4.29688 11.9749 3.35938 13.456 3.35938H14.974V0.273438C14.974 0.273438 13.6041 0 12.3081 0C9.60519 0 7.82792 1.75781 7.82792 4.88281V7.65625H4.79175V11.25H7.82792V20H11.5306V11.25H14.3076Z\" fill=\"#F5F5F5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol